import type { Options } from "react-markdown";

import { mentionId, splitMentions } from "./mentions";

/** O mínimo da árvore hast que o plugin toca. */
export interface HastNode {
  type: string;
  tagName?: string;
  value?: string;
  properties?: Record<string, unknown>;
  children?: HastNode[];
}

// Dentro de código e de link a referência fica como texto: é exemplo, não citação.
const SKIP = new Set(["code", "pre", "a"]);

function expand(node: HastNode): HastNode[] {
  if (node.type !== "text") {
    walk(node);
    return [node];
  }
  return splitMentions(node.value ?? "").map((part) =>
    typeof part === "string"
      ? { type: "text", value: part }
      : {
          type: "element",
          tagName: "span",
          properties: {
            dataMention: mentionId(part),
            dataKind: part.kind,
            dataKey: part.key,
          },
          children: [],
        },
  );
}

function walk(node: HastNode): void {
  if (!node.children || (node.type === "element" && SKIP.has(node.tagName ?? ""))) return;
  node.children = node.children.flatMap(expand);
}

/**
 * Na visão renderizada da instrução (AB#87442), cada referência vira um
 * `<span data-mention>`, que o componente desenha como chip.
 */
export function rehypeMentions() {
  return (tree: HastNode) => walk(tree);
}

/** Um item de `rehypePlugins`, no contrato do próprio react-markdown. */
type RehypePlugin = NonNullable<Options["rehypePlugins"]>[number];

/** O plugin como o react-markdown o recebe; a atribuição confere o contrato, sem cast. */
export const rehypeMentionsPlugin: RehypePlugin = rehypeMentions;
